module.exports = __webpack_public_path__ + "img/ellips-gradient.bb1467f7.svg";